import { Dialog, Transition } from '@headlessui/react';
import { Fragment, ReactNode } from 'react';

export type ModalV2Props = {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode | ReactNode[];
};

function ModalV2({ isOpen, onClose, children }: ModalV2Props): JSX.Element {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[999]" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/40" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white shadow-xl transition-all flex flex-col">
                                {children}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

type ModalSectionProps = {
    children: ReactNode | ReactNode[];
};

function Header({ children }: ModalSectionProps): JSX.Element {
    return <div className="border-b p-4">{children}</div>;
}

function Body({ children }: ModalSectionProps): JSX.Element {
    return <div className="p-4">{children}</div>;
}

function Footer({ children }: ModalSectionProps): JSX.Element {
    return <div className="border-t p-4">{children}</div>;
}

const _ModalV2 = Object.assign(ModalV2, { Header, Body, Footer });

export default _ModalV2;
